import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	CLUSTER_FEATURE_KEY,
	ClusterState,
	ClusterPartialState,
	clusterAdapter
} from './cluster.reducer';

// Lookup the 'Cluster' feature state managed by NgRx
export const getClusterState = createFeatureSelector<
	ClusterPartialState,
	ClusterState
>(CLUSTER_FEATURE_KEY);

const { selectAll, selectEntities } = clusterAdapter.getSelectors();

export const getClusterLoaded = createSelector(
	getClusterState,
	(state: ClusterState) => state.loaded
);

export const getClusterError = createSelector(
	getClusterState,
	(state: ClusterState) => state.error
);

export const loadingCluster = createSelector(
	getClusterState,
	(state: ClusterState) => state.loaded
);

export const getAllCluster = createSelector(
	getClusterState,
	(state: ClusterState) => selectAll(state)
);

export const getClusterEntities = createSelector(
	getClusterState,
	(state: ClusterState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getClusterState,
	(state: ClusterState) => state.selectedClusterId
);

export const getSelected = createSelector(
	getClusterEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
